import { List, fromJS } from 'immutable';
import { THEME, getStaticLegacyThemes } from 'reporting-ui-components/constants/themes';
import { getBrandKit } from 'reporting-ui-components/reports/utils/colors/brandKitUtils';
/**
 * Gets the appropriate color scheme/palette for chart visualization based on color configuration.
 *
 * This function resolves color themes by checking for brand kit palettes first, then falling back
 * to a theme if configured.
 *
 * @internal
 * @param {Object} params - The parameters object
 * @param {ChartTypeVisualizationColors} params.colorConfig - The color configuration object containing theme and brandKitId
 * @param {UnifiedBrandKitPalettes} [params.brandKitPalettes] - Optional brand kit palettes for custom color schemes
 * @returns {any} The resolved color scheme - either a brand kit scheme or a static legacy theme
 */
export const getPaletteColorScheme = ({
  colorConfig,
  brandKitPalettes,
  reportingThemes
}) => {
  var _reportingThemes, _reverse, _ref;
  reportingThemes = (_reportingThemes = reportingThemes) !== null && _reportingThemes !== void 0 ? _reportingThemes : getStaticLegacyThemes('reporting-ui-components.colorUtils.getPaletteColorScheme');
  const immutableColorConfig = fromJS(colorConfig);
  const paletteTheme = immutableColorConfig.get('theme');
  const brandKitId = immutableColorConfig.get('brandKitId');
  const {
    scheme: brandKitScheme
  } = getBrandKit(paletteTheme, brandKitPalettes, brandKitId) || {};

  // TODO: fix this typing
  const result = brandKitScheme || (paletteTheme !== THEME.MULTI ? ((_reverse = (_ref = reportingThemes.get(paletteTheme, List())).reverse) === null || _reverse === void 0 ? void 0 : _reverse.call(_ref)) ||
  // pattern theme is not a list and cannot be reversed
  reportingThemes.get(paletteTheme, List()) : reportingThemes.get(THEME.MULTI));
  return result;
};